<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add University</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update University</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addUniversityForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input class="form-control" id="name" type="text" formControlName="name">
                                        <small *ngIf="submitted && addUniversityForm.get('name').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="short_name">Short Name</label>
                                        <input class="form-control" id="short_name" type="text"
                                               formControlName="short_name">
                                        <small *ngIf="submitted && addUniversityForm.get('short_name').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input class="form-control" id="email" type="text" formControlName="email">
                                        <small *ngIf="submitted && addUniversityForm.get('email').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                        <small *ngIf="submitted && addUniversityForm.controls['email'].errors && addUniversityForm.controls['email'].errors.pattern"
                                               class="text-danger">Invalid email format</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="short-url">Short Url</label>
                                        <input class="form-control" id="short-url" type="text" formControlName="short_url">
                                        <small *ngIf="submitted && addUniversityForm.get('short_url').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="em_rank">EM Rank</label>
                                        <input class="form-control" id="em_rank" type="text" formControlName="em_rank">
                                        <small *ngIf="submitted && addUniversityForm.get('em_rank').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                        <small *ngIf="submitted && addUniversityForm.controls['em_rank'].errors && addUniversityForm.controls['em_rank'].errors.pattern"
                                               class="text-danger">Invalid EM-Rank</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="nirf_rank">NIRF Rank</label>
                                        <input class="form-control" id="nirf_rank" type="text"
                                               formControlName="nirf_rank">
                                        <small *ngIf="submitted && addUniversityForm.get('nirf_rank').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                        <small *ngIf="submitted && addUniversityForm.controls['nirf_rank'].errors && addUniversityForm.controls['nirf_rank'].errors.pattern"
                                               class="text-danger">Invalid NIRF-Rank</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="rating">Rating</label>
                                        <input class="form-control" id="rating" type="text"
                                               formControlName="rating">
                                        <small *ngIf="submitted && addUniversityForm.get('rating').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                        <small *ngIf="submitted && addUniversityForm.controls['rating'].errors && addUniversityForm.controls['rating'].errors.pattern"
                                               class="text-danger">Invalid NIRF-Rank</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group form-check">
                                        <input class="form-check-input" id="is_popular" type="checkbox"
                                               formControlName="is_popular">
                                        <label class="form-check-label" for="is_popular">Popular University</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group form-check">
                                        <input class="form-check-input" id="is_international" type="checkbox"
                                               formControlName="is_international" (change)="onInternationalToggle()">
                                        <label class="form-check-label" for="is_international">International University</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contact">Contact</label>
                                        <input class="form-control" id="contact" type="tel"
                                               formControlName="contact">
                                        <small *ngIf="submitted && addUniversityForm.get('contact').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                        <small *ngIf="submitted && addUniversityForm.controls['contact'].errors && addUniversityForm.controls['contact'].errors.pattern"
                                               class="text-danger">Invalid contact format</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="!data || !data.id">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="password" class="d-flex">
                                            Password
                                            <i (click)="inputTypePassword = 'text'"
                                               [ngClass]="{'display-hidden': (inputTypePassword === 'text')}"
                                               class="fas fa-eye-slash d-flex align-items-center pl-1 cursor-pointer"></i>
                                            <i (click)="inputTypePassword = 'password'"
                                               [ngClass]="{'display-hidden': (inputTypePassword === 'password')}"
                                               class="fas fa-eye d-flex align-items-center pl-1  cursor-pointer"></i>
                                        </label>
                                        <input class="form-control" id="password" [type]="inputTypePassword"
                                               formControlName="password">
                                        <small *ngIf="submitted && addUniversityForm.get('password').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="short_description">Short Description</label>
                                        <textarea class="form-control resize-none" id="short_description" type="text"
                                                  rows="3"
                                                  formControlName="short_description"></textarea>
                                        <small *ngIf="submitted && addUniversityForm.get('short_description').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="address">Address</label>
                                        <textarea class="form-control resize-none" id="address" type="text" rows="3"
                                                  formControlName="address"></textarea>
                                        <small *ngIf="submitted && addUniversityForm.get('address').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="!addUniversityForm.value.is_international">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="state">State</label>
                                        <select class="form-control" id="state" formControlName="state_id">
                                            <option value="">Select State</option>
                                            <option [value]="state?.id"
                                                    *ngFor="let state of states">{{state?.name}}</option>
                                        </select>
                                        <small *ngIf="submitted && addUniversityForm.get('state_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="!addUniversityForm.value.is_international">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="other_city">City</label>
                                        <input class="form-control" id="other_city" type="text"
                                               formControlName="other_city">
                                        <small *ngIf="submitted && addUniversityForm.get('other_city').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="addUniversityForm.value.is_international">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="country_name">Country</label>
                                        <input class="form-control" id="country_name" type="text"
                                               formControlName="country_name">
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="addUniversityForm.value.is_international">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="city_name">City</label>
                                        <input class="form-control" id="city_name" type="text"
                                               formControlName="city_name">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="pin">Pin</label>
                                        <input class="form-control" id="pin"
                                               [type]="addUniversityForm.value.is_international ? 'text' : 'number'"
                                               formControlName="pin">
                                        <small *ngIf="submitted && addUniversityForm.get('pin').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="url">Website Url</label>
                                        <input class="form-control" id="url" type="text" formControlName="url">
                                        <small *ngIf="submitted && addUniversityForm.get('url').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close"
                                            (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>

